
import { Component, Emit, Prop, Vue, Model } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class FormSelect extends Vue {
  @Prop({ default: () => [], required: true }) options: Array<{
    label: string
    value: number | string
  }>
  @Prop({ default: 'value' }) specifyValue: string

  @Model('change', { type: [Number, String] }) readonly value!: number | string

  get selectValue() {
    return this.value
  }

  set selectValue(val: number | string) {
    this.$emit('change', val)
  }

  created() {}

  mounted() {}

  updated() {}

  destroyed() {}
}
